import styled from 'styled-components';

export const BubbleContainer = styled.div`
  background-color: #fff;
  width: 192px;
  height: 192px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 15px;
  font-weight: 600;
  position: relative;
  color: #001c56;
`;

export const BubbleChild = styled.div`
  background-color: #fff;
  width: 81px;
  height: 81px;
  position: absolute;
  top: -10px;
  border-radius: 100px;
  right: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 8px 6px #00000012;
`;

export const Quantity = styled.div`
  font-size: 52px;
  font-weight: 600;
  text-align: left;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  color: #001c56;
  font-size: 29px;
`;

export const SubTitle = styled.div`
  color: #001c56;
  opacity: 0.47;
  font-size: 17px;
`;
